export default __webpack_public_path__ + "static/media/pns2.76d7f251.png";